export default "__VITE_ASSET__CHIy1JhD__"